import React from 'react';
import { Lightbulb, Users, Rocket, Shield } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              About GenieFab
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Pioneering Automated Engineering Drawings
            </p>
          </div>

          {/* Main Content */}
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h3 className="text-2xl font-bold text-slate-900 mb-6">
                Our Vision & Mission
              </h3>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                At GenieFab, our vision is clear: to revolutionize the traditional engineering design process. 
                We recognized the significant time and effort spent on manual drafting, particularly for 
                pressure vessel and heat exchanger drawings.
              </p>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                Our response is GenieFab, an innovative SaaS solution built to automate these complex tasks, 
                turning days of work into just hours.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed">
                Our mission is to empower engineers and designers with intelligent tools that boost productivity, 
                enhance accuracy, and accelerate project delivery.
              </p>
            </div>
            
            <div className="lg:pl-8">
              <div className="bg-slate-50 rounded-2xl p-8">
                <h4 className="text-xl font-semibold text-slate-900 mb-6">What We're Building</h4>
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-slate-700 rounded-full mt-2"></div>
                    <span className="text-slate-600">Pressure Vessel Automation Tool (Available Now)</span>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-slate-400 rounded-full mt-2"></div>
                    <span className="text-slate-500">Heat Exchanger Automation (Coming Soon)</span>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-slate-400 rounded-full mt-2"></div>
                    <span className="text-slate-500">Advanced Engineering Tools (Roadmap)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Core Values */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center p-6 rounded-xl hover:bg-slate-50 transition-colors duration-200">
              <div className="w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <Lightbulb className="w-6 h-6 text-slate-700" />
              </div>
              <h4 className="text-lg font-semibold text-slate-900 mb-2">Innovation</h4>
              <p className="text-slate-600 text-sm">
                Cutting-edge automation technology that transforms traditional workflows
              </p>
            </div>

            <div className="text-center p-6 rounded-xl hover:bg-slate-50 transition-colors duration-200">
              <div className="w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <Shield className="w-6 h-6 text-slate-700" />
              </div>
              <h4 className="text-lg font-semibold text-slate-900 mb-2">Precision</h4>
              <p className="text-slate-600 text-sm">
                Unmatched accuracy in every drawing with automated quality control
              </p>
            </div>

            <div className="text-center p-6 rounded-xl hover:bg-slate-50 transition-colors duration-200">
              <div className="w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <Users className="w-6 h-6 text-slate-700" />
              </div>
              <h4 className="text-lg font-semibold text-slate-900 mb-2">Empowerment</h4>
              <p className="text-slate-600 text-sm">
                Freeing engineers to focus on high-value design and innovation
              </p>
            </div>

            <div className="text-center p-6 rounded-xl hover:bg-slate-50 transition-colors duration-200">
              <div className="w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <Rocket className="w-6 h-6 text-slate-700" />
              </div>
              <h4 className="text-lg font-semibold text-slate-900 mb-2">Growth</h4>
              <p className="text-slate-600 text-sm">
                Scalable solutions that evolve with your business needs
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;